import { GameConstants } from "../gameClientEvents/GameConstants";

export const MAX_POOL_SIZE: number = 60; 
export const initialPoolSize: number = 25;

export const SymbolValues = [{ id: 14, value: 2 }, { id: 15, value: 3 }, { id: 16, value: 4 }, { id: 17, value: 5 }, { id: 18, value: 6 }, { id: 19, value: 7 }, { id: 20, value: 8 }, { id: 21, value: 9 }, { id: 22, value: 10 }, { id: 23, value: 20 }, { id: 24, value: 50 }, { id: 25, value: 100 }];
export const SymbolValMap = SymbolValues.reduce<Record<number, any>>((acc, curr) => {
    acc[curr.id] = curr.value;
    return acc;
}, {});

export const symbolsConfig: Record<number, { blurSymName?: string; staticSymName?: string; skeleton: string; atlas: string }> = {
    0: {
        blurSymName: "wildBlur",
        staticSymName: "wildStatic",
        skeleton: "wildSkel",
        atlas: "wildAtlas"
    },
    1: {
        blurSymName: "lv4Blur",
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    2: {
        blurSymName: "lv3Blur",
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    3: {
        blurSymName: "lv2Blur",
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    4: {
        blurSymName: "lv1Blur",
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    5: {
        blurSymName: "hv4Blur",
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    6: {
        blurSymName: "hv3Blur",
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    7: {
        blurSymName: "hv2Blur",
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    8: {
        blurSymName: "hv1Blur",
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    12: {
        blurSymName: "scatterBlur",
        staticSymName: "scatterStatic",
        skeleton: "scatterSkel",
        atlas: "scatterAtlas"
    },
    13: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    20: {
        blurSymName: "invalidBlur",
        staticSymName: "invalidStatic",
        skeleton: "invalidSkel",
        atlas: "invalidAtlas"
    },
    // Add more mappings as needed
};

export function isOversizeSymbol(symbolIndex: number): boolean {
    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {
    let isLandingExist = true;
    if (symbolIndex == GameConstants.SCATTER_SYMBOL_ID || symbolIndex == GameConstants.SPECIAL_SYMBOL_ID) {
        isLandingExist = true;
    }
    return isLandingExist;
}

export function isIdleExist(symbolIndex: number): boolean {
    let isIdleExist = false;
    if (
        symbolIndex === 14
    ) {
        isIdleExist = true;
    }
    return isIdleExist;
}
